import { ResponseModel } from '@agent/agent-interface/helpzone/knowledge-base/models/responseModel';
import { Injectable } from '@angular/core';

import * as KnowledgeBaseAction from './knowledge-base.action';

export { KnowledgeBaseAction };

@Injectable({
  providedIn: 'root',
})
export class KnowledgeBaseDispatcher {
  public suggestedResults(suggestedResults: ResponseModel[]) {
    return KnowledgeBaseAction.SuggestedResults({ suggestedResults });
  }

  public searchResults(searchResults: ResponseModel[]) {
    return KnowledgeBaseAction.SearchResults({ searchResults });
  }
}
